// extracted by mini-css-extract-plugin
export default {"content":"content-yey031pe"};